import type { IconSvgObject } from './types';

const MonocleIcon: IconSvgObject = [
  ["circle", { cx: "8", cy: "7.50391", r: "6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "16", cy: "7.50391", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 16.5039V18.5039C22 18.6743 21.9858 18.8413 21.9585 19.0039M20 21.3332C19.6872 21.4438 19.3506 21.5039 19 21.5039C18.6494 21.5039 18.3128 21.4438 18 21.3332M16 16.5039V18.5039C16 18.6743 16.0142 18.8413 16.0415 19.0039M22 7.50391V4.50391M22 13.5039V10.5039M16 13.5039V9.50391", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MonocleIcon;
